import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChange, getFirebaseIdToken } from '../firebase/auth';

const FirebaseAuthContext = createContext();

export const useFirebaseAuth = () => {
  const context = useContext(FirebaseAuthContext);
  if (!context) {
    throw new Error('useFirebaseAuth must be used within a FirebaseAuthProvider');
  }
  return context;
};

export const FirebaseAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [firebaseToken, setFirebaseToken] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChange(async (user) => {
      setUser(user);
      setLoading(false);
      
      if (user) {
        // Get Firebase ID token when user is authenticated
        try {
          const token = await getFirebaseIdToken();
          setFirebaseToken(token);
        } catch (error) {
          console.error('Error getting Firebase token:', error);
          setFirebaseToken(null);
        }
      } else {
        setFirebaseToken(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const value = {
    user,
    loading,
    firebaseToken,
    isAuthenticated: !!user
  };

  return (
    <FirebaseAuthContext.Provider value={value}>
      {children}
    </FirebaseAuthContext.Provider>
  );
};


